import { useEffect } from 'react';
import { useRequestFormStore } from 'src/features/requests/request-form';
import { WebViewAuthService } from 'src/services/Auth/WebView.auth';
import { getIsCreateRequestFromWebviewConfig } from 'src/utils/webview-detection';

/**
 * Component that automatically opens the RequestWizard when the app
 * is loaded from a ReactNative WebView with specific URL parameters
 */
export const WebViewWizardInitializer = () => {
  const { openModal, discardModal, isModalOpen } = useRequestFormStore();

  const handleOpenModal = () => {
    if (getIsCreateRequestFromWebviewConfig()) {
      openModal({
        isMultiStep: true,
        currentStep: 0,
      });
    } else {
      discardModal();
    }
  };

  useEffect(() => {
    if (!WebViewAuthService.isWebViewAuthEnabled() || !getIsCreateRequestFromWebviewConfig()) {
      return;
    }
    if (!isModalOpen) {
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: 'NAVIGATE',
          secure: true,
          to: '/requests',
          params: {
            isCreate: !!getIsCreateRequestFromWebviewConfig(),
          },
        }),
      );
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (!WebViewAuthService.isWebViewAuthEnabled()) return;
    handleOpenModal();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handleOpenModal();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null; // This component doesn't render anything
};
